import React from 'react';
import Flex from '@components/Flex/Flex';
import {
  StyledTitle,
  StyledSubTitle,
  StyledDivider,
  StyledContainer,
  StyledSmallTitle,
} from './HeaderTitleTile.styles';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { HeaderTitleTileProps, SubtitlesProps } from './HeaderTitleTile.types';
import { noop } from 'lodash';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { useNavigate } from 'react-router-dom';

const HeaderTitleTile: React.FC<HeaderTitleTileProps> = ({
  title,
  subtitles,
  smallTitle = false,
}) => {
  const navigate = useNavigate();
  const { sm: isMobile } = useMediaQueries();

  const handleSubTitleClick = (subTitle: SubtitlesProps, index: number) => {
    if (subtitles && index !== subtitles.length - 1) {
      navigate(subTitle?.to ?? '', { replace: true, ...subTitle.options });
    } else {
      noop();
    }
  };

  const handleBackArrowClick = () => {
    navigate(-1);
  };

  return (
    <StyledContainer>
      <div style={{ cursor: subtitles ? 'pointer' : 'auto' }}>
        <Flex alignItems='center'>
          {subtitles && (
            <Flex
              pr={6}
              data-testid='header-tile-back-click-handler'
              onClick={handleBackArrowClick}
            >
              <ArrowBackIosNewOutlinedIcon fontSize='inherit' />
            </Flex>
          )}
          {smallTitle && !subtitles ? (
            <StyledSmallTitle variant='h6' fontWeight='fontWeightSemiBold'>
              {title.name}
            </StyledSmallTitle>
          ) : (
            <StyledTitle
              isSubtitle={!!subtitles}
              variant={subtitles ? 'h6' : 'h4'}
              fontWeight='fontWeightSemiBold'
              data-testid='header-tile-title'
              onClick={() =>
                navigate(title?.to ?? '', {
                  replace: true,
                  ...title.options,
                })
              }
            >
              {title.name}
            </StyledTitle>
          )}
          {subtitles && !isMobile && (
            <StyledDivider variant='h6' fontWeight='fontWeightSemiBold'>
              /
            </StyledDivider>
          )}
        </Flex>
      </div>
      {subtitles &&
        subtitles.map((x, i) => (
          <React.Fragment key={x.name?.toString()}>
            <Flex
              style={{
                cursor: i !== subtitles.length - 1 ? 'pointer' : 'auto',
              }}
              data-testid={`${x.name}-header-tile-subtitle`}
              onClick={() => handleSubTitleClick(x, i)}
            >
              <StyledSubTitle
                variant='h6'
                fontWeight='fontWeightSemiBold'
                isLastTitle={i === subtitles.length - 1}
              >
                {x.name}
              </StyledSubTitle>
              {i !== subtitles.length - 1 && (
                <StyledDivider variant='h6' fontWeight='fontWeightSemiBold'>
                  /
                </StyledDivider>
              )}
            </Flex>
          </React.Fragment>
        ))}
    </StyledContainer>
  );
};

export default HeaderTitleTile;
